import { LIMIT_ACCORDANCES_PER_PAGE, LIMIT_DETAILS_FOR_COMPONENT_FULL_SCREEN, LIMIT_DETAILS_FOR_COMPONENT_SINGLE_VIEW, LIMIT_PRODUCTS_PER_PAGE, LIMIT_RISKS_PER_PAGE, LIMIT_WORDS_FOR_COMPONENT_SINGLE_VIEW, LIMIT_WORDS_FOR_RISKS_VIEW, RISK_CONTENT_KEY, SUBPRODUCT_CONTENT_KEY } from "../Constants/ProjectReportConstants";
import { AcquisitionsSection } from "../../view/ExtendedReport/AcquisitionsSection";
import { CurrentAccordancesSection } from "../../view/ExtendedReport/CurrentAccordancesSection";
import { FinancialInfoSection } from "../../view/ExtendedReport/FinancialInfoSection";
import { FinancialTCDISection } from "../../view/ExtendedReport/FinancialTCDISection";
import { ProductsSection } from "../../view/ExtendedReport/ProductsSection";
import { RisksSection } from "../../view/ExtendedReport/RisksSection";
import { SupervitionSection } from "../../view/ExtendedReport/SupervitionSection";
import { PMRProjectSummary } from "../../view/PMRProjectSummary";
import TCDIProjectSummary from "../../view/TCDIProjectSummary";
import { filterProductsByLatestYear } from "../Helpers/FilterProductsSourceHelper";
import { getComponentBalancesDataSource } from "../Helpers/MapperHelper";
import { getMaxItemsByWordLimit } from "../Helpers/StringHelper";

export const SECTIONS_CONFIG = {
  'general-info': {
    getComponent: (data) => data.isPMRType ? PMRProjectSummary : TCDIProjectSummary,
    paginate: false
  },
  'financial-info': {
    getComponent: (data) => data.isPMRType ? FinancialInfoSection : FinancialTCDISection,
    paginate: false
  },
  'current_accordances': {
    getComponent: () => CurrentAccordancesSection,
    paginate: true,
    dataKey: 'currentAccordances',
    dataSource: (data) => data.sectionThreeCurrentAccordances?.currentAccordances || [],
    limit: LIMIT_ACCORDANCES_PER_PAGE,
    isDynamicLimit: false,
    countKey: 'accordancesCount'
  },
  'risks': {
    getComponent: () => RisksSection,
    paginate: true,
    dataKey: 'risksDescriptions',
    dataSource: (data) => (data.sectionFourRiskOrProduct?.risk?.riskProgramSeverity).sort((a,b) => a.nameRiskType.localeCompare(b.nameRiskType)) || [],
    limit: LIMIT_RISKS_PER_PAGE,
    isDynamicLimit: true,
    getDynamicLimit: (items) => {return getMaxItemsByWordLimit(items, RISK_CONTENT_KEY, LIMIT_WORDS_FOR_RISKS_VIEW)},
    countKey: 'risksCount'
  },
  'acquisitions': {
    getComponent: () => AcquisitionsSection,
    paginate: true,
    dataKey: 'acquistionProcessProducts',
    dataSource: (data) => {return getComponentBalancesDataSource(data.sectionFiveAcquisition?.componentBalances)},
    limit: LIMIT_DETAILS_FOR_COMPONENT_SINGLE_VIEW,
    limitFullScreen: LIMIT_DETAILS_FOR_COMPONENT_FULL_SCREEN,
    isDynamicLimit: true,
    getDynamicLimit: (items) => {return getMaxItemsByWordLimit(items, SUBPRODUCT_CONTENT_KEY, LIMIT_WORDS_FOR_COMPONENT_SINGLE_VIEW)},
    countKey: 'subproductsCount',
    fullScreenKey: 'showProductsInFullScreen'
  },
  'supervition': {
    getComponent: () => SupervitionSection,
    paginate: false
  },
  'products': {
    getComponent: () => ProductsSection,
    paginate: true,
    dataKey: 'products',
    dataSource: (data) => { return filterProductsByLatestYear(data.sectionFourRiskOrProduct?.productCts) },
    limit: LIMIT_PRODUCTS_PER_PAGE,
    isDynamicLimit: false,
    countKey: 'productsCount'
  }
};
